const styles = {
  fullHeight: {
    height: '100%',
  },
};

export default styles;
